module.exports = __webpack_public_path__ + "static/media/Insurance-Cases.cfb872ab.jpg";